module.exports = __webpack_public_path__ + "static/scale-model-of-sandy-springs-georgia-4b7c1969725002f00305e40dd1306a24.png";